import { FC, ReactNode } from 'react';
import { useUID } from 'dibs-uid';

import styles from './LinkColumn.scss';
type Props = {
    title: ReactNode;
};

const LinkColumn: FC<Props> = ({ title, children }) => {
    const uid = useUID();
    const labelId = `${uid || title}-label`;
    return (
        <div className={styles.column}>
            <div id={labelId} className={styles.title}>
                {title}
            </div>
            <ul aria-labelledby={labelId} className={styles.list}>
                {children}
            </ul>
        </div>
    );
};

export default LinkColumn;
